import { createContext } from 'react';
import type { ScrapeJob } from '../types';

interface ScrapeContextType {
    jobs: ScrapeJob[];
    addJob: (job: ScrapeJob) => Promise<ScrapeJob>;
    updateJob: (id: string, updates: Partial<ScrapeJob>) => Promise<void>;
    fetchJobs: (silent?: boolean) => Promise<void>;
    loading: boolean;
}

export const ScrapeContext = createContext<ScrapeContextType | undefined>(undefined);